import { render } from "./bank_items.vue?vue&type=template&id=56cda54e&scoped=true"
import script from "./bank_items.vue?vue&type=script&lang=js"
export * from "./bank_items.vue?vue&type=script&lang=js"

import "./bank_items.vue?vue&type=style&index=0&id=56cda54e&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56cda54e"]])

export default __exports__